/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';

const Home: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitted(true);
    setEmail('');
  };

  const styles = {
    container: {
      fontFamily: 'Inter, sans-serif',
      background: '#f9fbfc',
      color: '#1a1a1a',
      padding: '0 1.5rem',
      maxWidth: '1200px',
      margin: '0 auto',
    },
    header: {
      padding: '3rem 0 2rem',
      textAlign: 'center' as const,
    },
    logo: {
      fontSize: '2.8rem',
      fontWeight: 800,
      color: '#1a73e8',
    },
    tagline: {
      marginTop: '0.5rem',
      fontSize: '1.25rem',
      color: '#555',
    },
    hero: {
      marginTop: '3rem',
      textAlign: 'center' as const,
      padding: '2rem 1rem',
      background: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 8px 20px rgba(0,0,0,0.05)',
    },
    heroTitle: {
      fontSize: '2rem',
      fontWeight: 700,
      marginBottom: '1rem',
    },
    heroText: {
      fontSize: '1.1rem',
      color: '#444',
      marginBottom: '2rem',
    },
    demoBox: {
      width: '100%',
      height: '360px',
      background: '#e8f0fe',
      border: '2px dashed #c2d4f5',
      borderRadius: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontStyle: 'italic',
      color: '#5f6368',
      marginBottom: '2rem',
    },
    features: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      justifyContent: 'space-between',
      gap: '2rem',
      marginBottom: '3rem',
    },
    featureBox: {
      flex: '1 1 250px',
      background: '#fff',
      padding: '1.5rem',
      borderRadius: '10px',
      boxShadow: '0 4px 10px rgba(0,0,0,0.05)',
    },
    featureTitle: {
      fontSize: '1.2rem',
      fontWeight: 600,
      marginBottom: '0.5rem',
    },
    featureText: {
      fontSize: '0.95rem',
      color: '#555',
    },
    formBox: {
      background: '#ffffff',
      padding: '2rem',
      borderRadius: '10px',
      textAlign: 'center' as const,
      boxShadow: '0 4px 16px rgba(0,0,0,0.06)',
      maxWidth: '450px',
      margin: '0 auto',
    },
    input: {
      padding: '0.8rem',
      width: '100%',
      fontSize: '1rem',
      borderRadius: '6px',
      border: '1px solid #ccc',
      marginBottom: '1rem',
    },
    button: {
      padding: '0.8rem 2rem',
      fontSize: '1rem',
      backgroundColor: '#1a73e8',
      color: '#fff',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      fontWeight: 600,
    },
    footer: {
      marginTop: '4rem',
      textAlign: 'center' as const,
      fontSize: '0.9rem',
      color: '#888',
      padding: '2rem 0',
    },
  };

  return (
      <div style={styles.container}>
        <header style={styles.header}>
          <div style={styles.logo}>QMagacin</div>
          <div style={styles.tagline}>Smarter Inventory Management for SMBs in North Macedonia</div>
        </header>

        <section style={styles.hero}>
          <h1 style={styles.heroTitle}>Organize your business with ease</h1>
          <p style={styles.heroText}>
            QMagacin helps you track stock, monitor performance, and streamline your inventory—
            all in one place. Built for small and growing businesses.
          </p>
          <div style={styles.demoBox}>Live Dashboard Preview (Coming Soon)</div>
        </section>
        <br/><br/><br/>
        <section style={styles.features}>
          <div style={styles.featureBox}>
            <div style={styles.featureTitle}>📦 Track Inventory</div>
            <div style={styles.featureText}>
              Monitor stock levels, item locations, and quantities in real-time.
            </div>
          </div>
          <div style={styles.featureBox}>
            <div style={styles.featureTitle}>📊 Analytics & Insights</div>
            <div style={styles.featureText}>
              Get insights into your best-sellers, restock needs, and trends.
            </div>
          </div>
          <div style={styles.featureBox}>
            <div style={styles.featureTitle}>🛠️ Easy Setup</div>
            <div style={styles.featureText}>
              Designed to be simple — start managing your warehouse in minutes.
            </div>
          </div>
        </section>



        <footer style={styles.footer}>
          © {new Date().getFullYear()} QMagacin. Built in North Macedonia.
        </footer>
      </div>
  );
};

export default Home;
